export enum ModuleName {
  Targeting = 'targeting',
  EngageAttendees = 'engage-attendees',
  CAI = 'cai',
  Ownership = 'ownership',
  Measure = 'measure',
  DataManagement = 'data-management',
  ProfilePage = 'profile-page',
  EngageActivities = 'engage-activities',
  InstitutionProfile = 'institution-profile',
  ContactProfile = 'contact-profile'
}
